(() => {
    class Offers extends App.Entities.Oldpoint {
        constructor() {
            super('offers');
            this.cache = true;
            this.isKeyable();
            this.setModel('Offer');
        }
    }
    App.Endpoint.Offers = new Offers();
})();
